import React from "react";

import { AvgViews } from "src/app/Task/tabs/ProfileDataTab/single/AvgViews";

export const renderAvgViews = (label, data, layout, GridBoxComponent) => {
  const {
    user_data: { avgViews },
    viewsStatisticsData,
  } = data;

  const height = layout?.find((item) => item.i === label)?.h;

  return (
    <GridBoxComponent key={label} id={label}>
      <AvgViews
        avgViews={avgViews}
        viewsStatisticsData={viewsStatisticsData}
        height={height}
      />
    </GridBoxComponent>
  );
};
